// Gullak Cash 业务类型枚举
export enum GullakBizType {
  Unknown = 0,      // 未知
  FirstCharge = 1,  // 首充
  Recharge = 2,     // 充值
  CasinoBet = 3,    // casino投注
  SportsEntry = 4,  // sports报名
  RummyEntry = 5,   // rummy参赛
  Invite = 6,       // 邀请
  Withdraw = 7,     // 提现
  SystemAdd = 8,    // 手动添加amount
  SystemReduce = 9, // 手动减少amount
  Claim = 10,     // 领取
  BindPhone = 11, // 绑定手机
  PayReward = 12, // 支付加赠奖励
  VideoReward = 13, // 充值视频观看奖励
}

export const GULLAK_BIZ_TYPE_MAP_REPORT = {
  [GullakBizType.FirstCharge]: 'first deposit',
  [GullakBizType.Recharge]: 'deposit',
  [GullakBizType.CasinoBet]: 'casino bet',
  [GullakBizType.SportsEntry]: 'sports entry',
  [GullakBizType.RummyEntry]: 'rummy join',
  [GullakBizType.Invite]: 'invite',
  [GullakBizType.Withdraw]: 'withdraw',
  [GullakBizType.BindPhone]: 'bind mobile'
}

// 业务类型映射表
export const GULLAK_BIZ_TYPE_MAP: Record<GullakBizType, string> = {
  [GullakBizType.Unknown]: 'unKnown',
  [GullakBizType.FirstCharge]: 'obtainedViaFirstDeposit',
  [GullakBizType.Recharge]: 'obtainedViaTotalDeposits',
  [GullakBizType.CasinoBet]: 'obtainedViaBets',
  [GullakBizType.SportsEntry]: 'obtainedViaBets',
  [GullakBizType.RummyEntry]: 'obtainedViaBets',
  [GullakBizType.Invite]: 'obtainedViaReferrals',
  [GullakBizType.Withdraw]: 'obtainedViaWithdrawals',
  [GullakBizType.SystemAdd]: 'systemIssued',
  [GullakBizType.SystemReduce]: 'systemDeduction',
  [GullakBizType.Claim]: 'claimCash',
  [GullakBizType.BindPhone]: 'bindPhone',
  [GullakBizType.PayReward]: 'depositTutorialReward',
  [GullakBizType.VideoReward]: 'depositMethodReward',
};

// 根据业务类型获取显示文本
export function getBizTypeLabelKey(bizType: string | number | undefined): string {
  if (bizType === undefined || bizType === null) {
    return '--';
  }
  return GULLAK_BIZ_TYPE_MAP[bizType as GullakBizType] || '--';
}
